import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type SendTravelAlertOtpV1MutationVariables = Types.Exact<{
  input: Types.SendTravelAlertOtpInputV1;
}>;

export type SendTravelAlertOtpV1Mutation = {
  __typename?: 'Mutation';
  sendTravelAlertOtpV1: { __typename?: 'TravelAlertSendOtpResultV1'; verified: boolean; channel: Types.TravelAlertChannelV1; phoneNumber?: string | null; email?: string | null };
};

export type VerifyTravelAlertOtpV1MutationVariables = Types.Exact<{
  input: Types.VerifyTravelAlertOtpInputV1;
}>;

export type VerifyTravelAlertOtpV1Mutation = {
  __typename?: 'Mutation';
  verifyTravelAlertOtpV1: {
    __typename?: 'TravelAlertVerifyOtpResultV1';
    verified: boolean;
    channel: Types.TravelAlertChannelV1;
    phoneNumber?: string | null;
    email?: string | null;
    otpVerifyAttemptsUsed: number;
    otpVerifyMaxAttempts: number;
  };
};

export type CreateTravelAlertSubscriptionV1MutationVariables = Types.Exact<{
  input: Types.CreateTravelAlertSubscriptionInputV1;
}>;

export type CreateTravelAlertSubscriptionV1Mutation = {
  __typename?: 'Mutation';
  createTravelAlertSubscriptionV1: {
    __typename?: 'TravelAlertSubscriptionDtoV1';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSourceV1;
    status: Types.TravelAlertSubscriptionStatusV1;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerTypeV1>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  };
};

export type UpdateTravelAlertSubscriptionV1MutationVariables = Types.Exact<{
  input: Types.UpdateTravelAlertSubscriptionInputV1;
}>;

export type UpdateTravelAlertSubscriptionV1Mutation = {
  __typename?: 'Mutation';
  updateTravelAlertSubscriptionV1: {
    __typename?: 'TravelAlertSubscriptionDtoV1';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSourceV1;
    status: Types.TravelAlertSubscriptionStatusV1;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerTypeV1>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  };
};

export type TravelAlertSubscriptionV1QueryVariables = Types.Exact<{
  input: Types.TravelAlertSubscriptionQueryInputV1;
}>;

export type TravelAlertSubscriptionV1Query = {
  __typename?: 'Query';
  travelAlertSubscriptionV1?: {
    __typename?: 'TravelAlertSubscriptionDtoV1';
    id: string;
    eventId: string;
    phoneNumber: string;
    email?: string | null;
    anonymousId?: string | null;
    source: Types.TravelAlertSubscriptionSourceV1;
    status: Types.TravelAlertSubscriptionStatusV1;
    subscribedAlertTypes: Array<Types.TravelAlertTriggerTypeV1>;
    isVerifiedSubscription: boolean;
    consentAt: any;
    optedOutAt?: any | null;
    reEngagedAt?: any | null;
  } | null;
};

export const SendTravelAlertOtpV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendTravelAlertOtpV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendTravelAlertOtpInputV1' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendTravelAlertOtpV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SendTravelAlertOtpV1MutationFn = Apollo.MutationFunction<SendTravelAlertOtpV1Mutation, SendTravelAlertOtpV1MutationVariables>;

/**
 * __useSendTravelAlertOtpV1Mutation__
 *
 * To run a mutation, you first call `useSendTravelAlertOtpV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTravelAlertOtpV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTravelAlertOtpV1Mutation, { data, loading, error }] = useSendTravelAlertOtpV1Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendTravelAlertOtpV1Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTravelAlertOtpV1Mutation, SendTravelAlertOtpV1MutationVariables>) {
  return ApolloReactHooks.useMutation<SendTravelAlertOtpV1Mutation, SendTravelAlertOtpV1MutationVariables>(SendTravelAlertOtpV1Document, baseOptions);
}
export type SendTravelAlertOtpV1MutationHookResult = ReturnType<typeof useSendTravelAlertOtpV1Mutation>;
export type SendTravelAlertOtpV1MutationResult = Apollo.MutationResult<SendTravelAlertOtpV1Mutation>;
export type SendTravelAlertOtpV1MutationOptions = Apollo.BaseMutationOptions<SendTravelAlertOtpV1Mutation, SendTravelAlertOtpV1MutationVariables>;
export const VerifyTravelAlertOtpV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'VerifyTravelAlertOtpV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifyTravelAlertOtpInputV1' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyTravelAlertOtpV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'verified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otpVerifyAttemptsUsed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'otpVerifyMaxAttempts' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type VerifyTravelAlertOtpV1MutationFn = Apollo.MutationFunction<VerifyTravelAlertOtpV1Mutation, VerifyTravelAlertOtpV1MutationVariables>;

/**
 * __useVerifyTravelAlertOtpV1Mutation__
 *
 * To run a mutation, you first call `useVerifyTravelAlertOtpV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTravelAlertOtpV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTravelAlertOtpV1Mutation, { data, loading, error }] = useVerifyTravelAlertOtpV1Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyTravelAlertOtpV1Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyTravelAlertOtpV1Mutation, VerifyTravelAlertOtpV1MutationVariables>) {
  return ApolloReactHooks.useMutation<VerifyTravelAlertOtpV1Mutation, VerifyTravelAlertOtpV1MutationVariables>(VerifyTravelAlertOtpV1Document, baseOptions);
}
export type VerifyTravelAlertOtpV1MutationHookResult = ReturnType<typeof useVerifyTravelAlertOtpV1Mutation>;
export type VerifyTravelAlertOtpV1MutationResult = Apollo.MutationResult<VerifyTravelAlertOtpV1Mutation>;
export type VerifyTravelAlertOtpV1MutationOptions = Apollo.BaseMutationOptions<VerifyTravelAlertOtpV1Mutation, VerifyTravelAlertOtpV1MutationVariables>;
export const CreateTravelAlertSubscriptionV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateTravelAlertSubscriptionV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateTravelAlertSubscriptionInputV1' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTravelAlertSubscriptionV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type CreateTravelAlertSubscriptionV1MutationFn = Apollo.MutationFunction<CreateTravelAlertSubscriptionV1Mutation, CreateTravelAlertSubscriptionV1MutationVariables>;

/**
 * __useCreateTravelAlertSubscriptionV1Mutation__
 *
 * To run a mutation, you first call `useCreateTravelAlertSubscriptionV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTravelAlertSubscriptionV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTravelAlertSubscriptionV1Mutation, { data, loading, error }] = useCreateTravelAlertSubscriptionV1Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTravelAlertSubscriptionV1Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTravelAlertSubscriptionV1Mutation, CreateTravelAlertSubscriptionV1MutationVariables>,
) {
  return ApolloReactHooks.useMutation<CreateTravelAlertSubscriptionV1Mutation, CreateTravelAlertSubscriptionV1MutationVariables>(
    CreateTravelAlertSubscriptionV1Document,
    baseOptions,
  );
}
export type CreateTravelAlertSubscriptionV1MutationHookResult = ReturnType<typeof useCreateTravelAlertSubscriptionV1Mutation>;
export type CreateTravelAlertSubscriptionV1MutationResult = Apollo.MutationResult<CreateTravelAlertSubscriptionV1Mutation>;
export type CreateTravelAlertSubscriptionV1MutationOptions = Apollo.BaseMutationOptions<CreateTravelAlertSubscriptionV1Mutation, CreateTravelAlertSubscriptionV1MutationVariables>;
export const UpdateTravelAlertSubscriptionV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTravelAlertSubscriptionV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateTravelAlertSubscriptionInputV1' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTravelAlertSubscriptionV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateTravelAlertSubscriptionV1MutationFn = Apollo.MutationFunction<UpdateTravelAlertSubscriptionV1Mutation, UpdateTravelAlertSubscriptionV1MutationVariables>;

/**
 * __useUpdateTravelAlertSubscriptionV1Mutation__
 *
 * To run a mutation, you first call `useUpdateTravelAlertSubscriptionV1Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelAlertSubscriptionV1Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelAlertSubscriptionV1Mutation, { data, loading, error }] = useUpdateTravelAlertSubscriptionV1Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTravelAlertSubscriptionV1Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTravelAlertSubscriptionV1Mutation, UpdateTravelAlertSubscriptionV1MutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateTravelAlertSubscriptionV1Mutation, UpdateTravelAlertSubscriptionV1MutationVariables>(
    UpdateTravelAlertSubscriptionV1Document,
    baseOptions,
  );
}
export type UpdateTravelAlertSubscriptionV1MutationHookResult = ReturnType<typeof useUpdateTravelAlertSubscriptionV1Mutation>;
export type UpdateTravelAlertSubscriptionV1MutationResult = Apollo.MutationResult<UpdateTravelAlertSubscriptionV1Mutation>;
export type UpdateTravelAlertSubscriptionV1MutationOptions = Apollo.BaseMutationOptions<UpdateTravelAlertSubscriptionV1Mutation, UpdateTravelAlertSubscriptionV1MutationVariables>;
export const TravelAlertSubscriptionV1Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TravelAlertSubscriptionV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelAlertSubscriptionQueryInputV1' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'travelAlertSubscriptionV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'anonymousId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscribedAlertTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedSubscription' } },
                { kind: 'Field', name: { kind: 'Name', value: 'consentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'optedOutAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reEngagedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useTravelAlertSubscriptionV1Query__
 *
 * To run a query within a React component, call `useTravelAlertSubscriptionV1Query` and pass it any options that fit your needs.
 * When your component renders, `useTravelAlertSubscriptionV1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTravelAlertSubscriptionV1Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelAlertSubscriptionV1Query(baseOptions?: ApolloReactHooks.QueryHookOptions<TravelAlertSubscriptionV1Query, TravelAlertSubscriptionV1QueryVariables>) {
  return ApolloReactHooks.useQuery<TravelAlertSubscriptionV1Query, TravelAlertSubscriptionV1QueryVariables>(TravelAlertSubscriptionV1Document, baseOptions);
}
export function useTravelAlertSubscriptionV1LazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TravelAlertSubscriptionV1Query, TravelAlertSubscriptionV1QueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<TravelAlertSubscriptionV1Query, TravelAlertSubscriptionV1QueryVariables>(TravelAlertSubscriptionV1Document, baseOptions);
}
export type TravelAlertSubscriptionV1QueryHookResult = ReturnType<typeof useTravelAlertSubscriptionV1Query>;
export type TravelAlertSubscriptionV1LazyQueryHookResult = ReturnType<typeof useTravelAlertSubscriptionV1LazyQuery>;
export type TravelAlertSubscriptionV1QueryResult = Apollo.QueryResult<TravelAlertSubscriptionV1Query, TravelAlertSubscriptionV1QueryVariables>;
